module.exports = __webpack_public_path__ + "img/56.1d234899.jpeg";